import { useState } from "react";
import { Container, Image, Nav, NavDropdown, Navbar } from "react-bootstrap";
import { useAppConfig } from '../Utils/AppConfigContext';
import BrandLogo from '../logo.png';

const Header = () => {
    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const { config, loading, getAppName, getLogoUrl } = useAppConfig();

    // Use logo from config if available, otherwise fallback to default
    const logoSrc = getLogoUrl() || BrandLogo;
    const appName = getAppName();

    return (
        <>
            <Navbar bg="light" expand="lg" className="border-bottom bg-white ">
                <Container>
                    <Navbar.Brand href="/">
                        <Image
                            src={logoSrc}
                            alt={`${appName} Logo`}
                            style={{ height: '40px' }}
                            onError={(e) => {
                                // Fallback to default logo if config logo fails to load
                                e.target.src = BrandLogo;
                            }}
                        />
                        <span className="ms-2 fw-bold fs-12 px-2 py-1 border rounded">{`v${process.env.REACT_APP_VERSION}`}</span>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse>
                        <Nav className="ms-auto">
                            <Nav.Link href="/" title="Dashboard">Dashboard</Nav.Link>
                            {userLogin.role === 'admin' ?
                                <>
                                    <Nav.Link href="/customer" title="Pelanggan">Pelanggan</Nav.Link>
                                    <NavDropdown title="Penawaran" id="basic-nav-dropdown">
                                        <NavDropdown.Item href="/penawaran">Semua data</NavDropdown.Item>
                                        <NavDropdown.Item href="/penawaran/create">Input Penawaran</NavDropdown.Item>
                                    </NavDropdown>
                                    <Nav.Link href="/inspeksi" title="Data Inspeksi">Data Inspeksi</Nav.Link>
                                    <NavDropdown title="Tagihan" id="basic-nav-dropdown">
                                        <NavDropdown.Item href="/invoice">Semua data</NavDropdown.Item>
                                        <NavDropdown.Item href="/invoice/create">Input Tagihan</NavDropdown.Item>
                                    </NavDropdown>
                                    <NavDropdown title="Pembayaran" id="basic-nav-dropdown">
                                        <NavDropdown.Item href="/pembayaran">Semua data</NavDropdown.Item>
                                        <NavDropdown.Item href="/pembayaran/create">Input Pembayaran</NavDropdown.Item>
                                    </NavDropdown>
                                </> :
                                <Nav.Link href="/inspeksi" title="Inspeksi">Data Inspeksi</Nav.Link>
                            }
                            <NavDropdown title="Settings" id="setting-nav-dropdown">
                                {userLogin.role === 'admin' &&
                                    <>
                                        <NavDropdown.Item href="/options">Pengaturan Umum</NavDropdown.Item>
                                        <NavDropdown.Item href="/options/master/brand">Master Data Merek</NavDropdown.Item>
                                        <NavDropdown.Item href="/options/master/type">Master Data Tipe</NavDropdown.Item>
                                        <NavDropdown.Item href="/form-options">Pengaturan Inspeksi</NavDropdown.Item>
                                    </>
                                }
                            </NavDropdown>
                            <NavDropdown title="Akun" id="basic-nav-dropdown">
                                <NavDropdown.Item href="/account/profile">Ubah Profil Saya</NavDropdown.Item>
                                {userLogin.role === 'admin' &&
                                    <>
                                        <NavDropdown.Item href="/users">Data Pengguna Sistem</NavDropdown.Item>
                                    </>
                                }
                                <NavDropdown.Item href="/MANUALBOOK-PRO-CAR-INSPECTOR.pdf" target="_blank">Dokumentasi Sistem</NavDropdown.Item>
                                <NavDropdown.Item href="#" onClick={(e) => {
                                    window.localStorage.clear();
                                    window.location.assign('/login');
                                }} className="text-danger">Keluar</NavDropdown.Item>
                            </NavDropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
}

export default Header;
